import { Request } from '../../common/api';
import { type ApiResult, type BaseParams, type MetadataContent, type PostParams } from '../../common/structs';
import { links } from '../../links';

export interface ProxyRequest {
    service: ProxyService;
    data: string;
}

export enum ProxyService {
    RestPack = 'RestPack',
    Echo = 'Echo',
    Scraper = 'Scraper',
}

export interface ProxyResponse {
    value: string;
    json?: {
        meta: MetadataContent[];
    };
}

export async function callProxy(params: BaseParams & PostParams<ProxyRequest>): Promise<ApiResult<ProxyResponse>> {
    return Request.postRequest<ProxyResponse>({
        ...params,
        target: links.proxy(),
    });
}
